module.exports = __webpack_public_path__ + "5c7124360008934968ae21dbed205a6d.jpg";